import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import * as _ from "lodash";

const vUI_Policy_Area_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_POLICYAREA_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'WB Policy Area Id', columnResourceName: 'colId', alignment: HorizAlignment.Left},
        domainOptions: {}
    },
    POLICYAREA_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'ID', columnResourceName: 'colId', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    POLICYAREA_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 256}
    },
    COMMENTS: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Description', columnResourceName: 'colComments', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 5000}
    },
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
};

const PolicyAreaSearchProviderBasic: ISearchProvider = {

    keyFields: {
        id: 'WB_POLICYAREA_ID',
        id_ui: 'POLICYAREA_ID',
        name: 'POLICYAREA_NAME'
    },

    searchProviderFields: vUI_Policy_Area_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_PolicyArea_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                })
        })
    },

    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            let findRequest = SearchUtils.makeSearchRequest({},
                'vUI_PolicyArea_Search',
                this.searchProviderFields,
                [fieldName])


            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(_.map(res, (aRow) => {
                        return aRow[fieldName]
                    }))
                })
                .catch((err) => {
                    error(err)
                })
        })
    }
};

const PolicyAreaSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5ResourceId: "PolicyAreaSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'ID', searchProviderFieldId: 'POLICYAREA_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'POLICYAREA_NAME', renderOptions: {}},
        {profileFilterName: 'Description', searchProviderFieldId: 'COMMENTS', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'POLICYAREA_ID', 'POLICYAREA_NAME', 'COMMENTS',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ],

    profileSearchProvider: PolicyAreaSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const PolicyAreaSearch: ISearch = {
    searchName: "Find Policy Area",
    renderOptions: {ui5ResourceId: "PolicyAreaSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [PolicyAreaSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("PolicyAreaBO", "PolicyArea", PolicyAreaSearch, "Policy Area Search")

export {PolicyAreaSearch}
